// @TODO: <HEALTH2019>
(function () {
    App.factory('HealthInsuranceComplaintRefundService', healthInsuranceComplaintRefundFactory);

    healthInsuranceComplaintRefundFactory.$inject = ['Config', 'baseService'];

    function healthInsuranceComplaintRefundFactory(Config, baseService) {
        return new HealthInsuranceComplaintRefundService();

        function HealthInsuranceComplaintRefundService() {
            this.sendMotion = function (model) {
                var url = Config.API_URL + '/insurerNotification/save',
                    body;

                switch(model.type) {
                    case 'COMPLAINT':
                        body = prepareBodyComplaint(model);
                        break;
                    case 'REFUND':
                        body = prepareBodyRefund(model);
                        break;
                    case 'REFUND_70':
                        body = prepareBodyRebate(model);
                        break;
                }

                body = angular.toJson(body);

                var data = new FormData();
                data.append('params', new Blob([body], {type: 'application/json'}));
                if (model.serviceFiles && model.serviceFiles[0]) data.append('file1', model.serviceFiles[0]);
                if (model.serviceFiles && model.serviceFiles[1]) data.append('file2', model.serviceFiles[1]);
                if (model.serviceFiles && model.serviceFiles[2]) data.append('file3', model.serviceFiles[2]);

                return baseService.postFormData(url, data);
            };

            this.fetchHistory = function (currentPage, pageSize) {
                var url = Config.API_URL + '/insurerNotification/list?pageNumber=:pageNumber&pageSize=:pageSize';
                url = url.replace(/:pageNumber/g, currentPage);
                url = url.replace(/:pageSize/g, pageSize);

                return baseService.get(url);
            };

            this.hasAccessToForm = function () {
                var url = Config.API_URL + '/insurerNotification/shouldHaveAccessToModule';

                return baseService.get(url);
            };

            function prepareBodyComplaint(model) {
                return {
                    type: model.type,
                    description: model.complaint
                }
            }

            function prepareBodyRefund(model) {
                var toReturn = {
                    type: model.type,
                    insured: {id: model.person.id},
                    contactType: model.formOfContact.value,
                    accountNumber: model.bankAccountNumber,
                    visitType: model.serviceDescription,
                    
                    contactTime: prepareContactTime(model),
                    visitDate: prepareVisitDate(model),
                    visitPrice: prepareVisitPrice(model)
                };

                return toReturn;
            }

            function prepareBodyRebate(model) {
                var toReturn = {
                    type: model.type,
                    insured: {id: model.person.id},
                    accountNumber: model.bankAccountNumber,
                    visitType: model.serviceDescription,

                    visitDate: prepareVisitDate(model),
                    visitPrice: prepareVisitPrice(model)
                };

                return toReturn;
            }

            function prepareContactTime(model) {
                var date = new Date(),
                    y = model.contactDate.getFullYear(),
                    m = model.contactDate.getMonth(),
                    d = model.contactDate.getDate(),
                    splitted = model.contactTime.split(':');

                var hours = parseInt(splitted[0], 10),
                    minutes = parseInt(splitted[1], 10);

                date.setFullYear(y, m, d);
                date.setHours(hours, minutes, 0, 0);

                return date;
            }

            function prepareVisitDate(model) {
                var y = model.serviceDate.getFullYear(),
                    m = model.serviceDate.getMonth() + 1,
                    d = model.serviceDate.getDate();

                if (m < 10) m = '0' + m;
                if (d < 10) d = '0' + d;

                return '' + y + '-' + m + '-' + d;
            }
            
            function prepareVisitPrice(model) {
                return '' + parseFloat(model.servicePrice.replace(/,/g, '.'));
            }
        }
    }
})();
// @TODO: </HEALTH2019>
